import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataTableComponent from "../../components/DataTableComponent/DataTableComponent";
import bannerImage from "../../assets/images/agreement_banner.svg";
import scrollIcon from "../../assets/images/scroll-down.png";
import chat from "../../assets/images/chat.png";
import eye from "../../assets/images/eye.png";
import edit from "../../assets/images/Edit.png";
import agreementUpload from "../../assets/images/CloudDownload.png";
import UploadIcon from "../../assets/images/Folder.svg";
import userImage from "../../assets/images/profileavtar.png";
import profileavtar from "../../assets/images/profileavtar.png";
import MasterLayout from "../../components/Layout/MasterLayout";
import { CommentSideBar } from "../../components/CommentSideBar/CommentSideBar";
import { getItem, showSuccessToast } from "../../utils/Functions";
import { commentListing, signingListing } from "./actions";
import moment from "moment";
import {
  Badge,
  Card,
  Button,
  Col,
  Container,
  Modal,
  Image,
  Row,
  Form,
} from "react-bootstrap";
import { Drawer, Badge as AntdBadge } from "antd";
import { Typewriter } from "react-simple-typewriter";
import { scrollTo } from "../../components/AnimateScroll/scrollTo";
import { FileUploader } from "react-drag-drop-files";

const Agreements = () => {
  const dispatch = useDispatch();
  const signingRequestData = useSelector(
    (state) => state.agreement.signingListingData
  );
  const addCommentData = useSelector((state) => state.agreement.addCommentData);
  const [page] = useState(1);
  const [signingList, setSigningList] = useState([]);
  const [perPage, setPerPage] = useState(25);
  const [show, setShow] = useState(false);
  const [commentBar, setCommentBar] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState("");

  useEffect(() => {
    getSigningListing(page);
  }, []);

  useEffect(() => {
    if (addCommentData && addCommentData.status === 1) {
      showSuccessToast("Comment added successfully");
    }
  }, [addCommentData]);

  // useEffect(() => {
  //   signingRequestData.length > 0 && getSigningData(signingRequestData);
  // }, [signingRequestData]);

  const openCommentBar = (obj) => {
    setCommentBar(true);
    setSelectedDocument(obj.id);
    dispatch(
      commentListing({
        candidateId: JSON.parse(getItem("User"))._id,
        docId: obj.id,
      })
    );
  };

  const closeCommentBar = () => {
    setCommentBar(false);
    getSigningListing(page);
  };
  const closeModalHandler = () => {
    setShow(false);
  };

  const getSigningListing = async (page) => {
    const payload = {
      page: page,
      pageSize: perPage,
      candidateId: JSON.parse(getItem("User"))._id,
    };
    await dispatch(signingListing(payload));
  };

  const columns = [
    // {
    //   id: 1,
    //   name: "Sr.no",
    //   selector: (row) => row.id,
    //   sortable: true,
    //   grow: 0.1,
    // },
    {
      id: 2,
      name: "File Name",
      selector: (row) => row.request_name,
      sortable: true,
      grow: 1,
    },
    {
      id: 3,
      name: "Status",
      selector: (row) => row.request_status,
      sortable: true,
    },
    {
      id: 3,
      name: "Date",
      selector: (row) => moment(row.modified_time).format("DD-MMM-YY"),
      sortable: true,
    },
    // {
    //   id: 4,
    //   name: "Initiated On",
    //   selector: (row) => (
    //     <div class="date">
    //       <p className="mb-1">{row.date}</p> <p className="time">{row.time}</p>
    //     </div>
    //   ),
    //   grow: 2,
    //   sortable: true,
    //   reorder: true,
    // },
    // {
    //   id: 5,
    //   name: "Requested by",
    //   selector: (row) => (
    //     <div className="d-flex">
    //       {/* <img src={profilePic} className="me-2" /> */}
    //       <div class="date">
    //         <p className="mb-1">{row.requested_name}</p>{" "}
    //         <p className="time">{row.designation}</p>
    //       </div>
    //     </div>
    //   ),
    //   sortable: true,
    //   grow: 2,
    // },
    // {
    //   id: 6,
    //   name: "Status",
    //   selector: (row) => (
    //     <span className={row.status === "signed" ? "green-badge" : "red-badge"}>
    //       {row.status}
    //     </span>
    //   ),
    //   grow: 1,
    //   sortable: true,
    // },
    // {
    //   id: 7,
    //   name: "Comment",
    //   // call here the comment sidebar box component
    //   selector: (row) => row.view,
    //   // <div onClick={() => openCommentBar()} className="border-0">
    //   //   <img src={row.view} />
    //   // </div>
    //   sortable: true,
    //   grow: 0.6,
    // },
    // {
    //   id: 7,
    //   selector: (row) => (
    //     <div className="view-actions">
    //       <a className="me-3">
    //         <img src={row.edit} onClick={() => setShow(true)} />
    //       </a>
    //       <a className="me-3">
    //         <img src={row.eye} />
    //       </a>
    //       <a>
    //         <img src={row.download} />
    //       </a>
    //     </div>
    //   ),
    //   name: "View",
    //   sortable: true,
    // },
  ];
  const getSigningData = (signingData) => {
    const listData = [];
    signingData &&
      signingData.map((item) => {
        return listData.push({
          id: item.docId,
          name: item.docName,
          sigin: item.typeOfSigning,
          date: item && moment(item.updatedAt).format("DD MMMM YYYY"),
          time: item && moment(item.updatedAt).format("hh:mm A"),
          requested_name:
            item.requestedBy.firstName + " " + item.requestedBy.lastName,
          designation: "",
          status: item.status === "Send" ? "Not Signed" : "Signed",
          view: (
            <>
              {" "}
              <div
                onClick={() =>
                  openCommentBar({ docId: item.docId, id: item._id })
                }
                className="border-0"
              >
                <img src={chat} />
                <sup>
                  <AntdBadge
                    count={item && item.candidateUnSeenDiscussion.length}
                  />
                </sup>
              </div>
            </>
          ),
          edit: edit,
          eye: eye,
          // download: CloudDownload,
        });
      });
    setSigningList(listData);
  };

  /******************* 
  @Purpose : Used to handle scroll
  @Parameter :()
  @Author : INIC
  ******************/
  const handleScroll = () => {
    document.getElementById("uploadBtn");
    scrollTo({ id: "upload-document" });
  };

  /******************* 
  @Purpose : Ant-Drawer for comment modal
  @Parameter :
  @Author : INIC
  ******************/
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  // const docs = [
  //   {
  //     uri: docPreviewData.filePath,
  //   },
  // ];

  return (
    <>
      <MasterLayout>
        {/* Start: Hero/Banner Image */}
        <section className="home-banner-wrap">
          <Container>
            <Row>
              <Col sm={6} className="my-auto">
                <h5 className="banner-sub-caption">
                  Welcome to Candidate Portal
                </h5>
                <h1 className="banner-main-caption">
                  Upload your{" "}
                  <strong>
                    <Typewriter
                      words={["Agreements..."]}
                      loop={1}
                      typeSpeed={130}
                      deleteSpeed={50}
                      delaySpeed={1000}
                    />
                  </strong>
                </h1>
                <Button
                  variant="primary"
                  id="uploadBtn"
                  className="btn-upload"
                  onClick={() => handleScroll()}
                >
                  Upload here <span className="bx bxs-chevron-down"></span>
                </Button>
              </Col>
              <Col sm={6}>
                <div className="banner-img">
                  <Image src={bannerImage} alt="Upload Image" />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* Ends: Hero/Banner Image */}

        <div
          id="mouse_scroll"
          className="mouse_arrow"
          onClick={() => handleScroll()}
        >
          <a className="mouse_icon d-flex" title="Scroll Down">
            <Image
              src={scrollIcon}
              alt="Scroll Down Icon"
              className="scroll-icon"
            />
          </a>
        </div>

        <section className="my-agreements" id="upload-document">
          <Container>
            <div className="section-title">
              <h1 className="title">My Agreements</h1>
              <span className="divider"></span>
              <p className="sub-title">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
                <br />
                When an unknown printer took a galley of type and scrambled it
                to make a type specimen book.
              </p>
            </div>
            <div className="agreement-detailed upload-documents">
              <div className="file-uploader">
                <Col lg={4} md={6} className="mb-4">
                  <Card
                  // className={
                  //   item.status === "Decline" &&
                  //   "document-rejected"
                  // }
                  >
                    <Card.Header className="p-0">
                      <div className="document-preview-container">
                        {/* {urlType === "pdf" && (
                          <object
                            data={s3bucketUrl + item.docPath}
                            type="application/pdf"
                            style={{
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        )} */}
                        {/* {urlType === "jpeg" && ( */}
                        <Card.Img
                          variant="top"
                          // src={s3bucketUrl + item.docPath}
                          src={agreementUpload}
                          alt="Document Image"
                        />
                        {/* )} */}
                        {/* {urlType === "jpg" && (
                          <Card.Img
                            variant="top"
                            src={s3bucketUrl + item.docPath}
                            alt="Document Image"
                          />
                        )}
                        {urlType === "png" && (
                          <Card.Img
                            variant="top"
                            src={s3bucketUrl + item.docPath}
                            alt="Document Image"
                          />
                        )} */}
                      </div>
                      <div className="change-options">
                        <input
                          type="checkbox"
                          // id={`AddressProof${index}`}
                          className="change-toggle"
                          // onClick={() => {
                          //   handleActions(true, index);
                          // }}
                        ></input>
                        <label
                          title="Click Here"
                          // htmlFor={`AddressProof${index}`}
                          className="change-button"
                        >
                          <span className="bx bx-plus-circle"></span>
                        </label>

                        <a
                          title="Re-upload"
                          // onClick={() =>
                          //   handleReUpload(true, index)
                          // }
                          className="change-icon"
                        >
                          <span
                            className="bx bx-upload"
                            title="Re-Upload"
                          ></span>
                        </a>
                        {/* {item &&
                        item?.status === "Accepted" ? null : ( */}
                        <a
                          title="Delete"
                          // onClick={() => handleDocDelete(item)}
                          className="change-icon"
                        >
                          <span className="bx bx-trash" title="Delete"></span>
                        </a>
                        {/* )} */}
                        <a
                          title="Preview"
                          // onClick={() => {
                          //   setModalShow(true);
                          //   setDocPreviewData({
                          //     filePath:
                          //       s3bucketUrl + item.docPath,
                          //     urlType: urlType,
                          //   });
                          // }}
                          className="change-icon"
                        >
                          <span className="bx bx-show"></span>
                        </a>
                      </div>
                    </Card.Header>
                    <Card.Body className="p-0">
                      <div className="section-title-heading flex-grow-1 mt-4 mb-2">
                        <div className="doc-title w-75">
                          <h5 className="doc-name font-weight-medium text-truncate mb-0">
                            {/* {item.docName} */} Joining Letter
                          </h5>
                          <span className="divider"></span>
                        </div>
                        <div>
                          <AntdBadge
                            count={
                              // item &&
                              // item.candidateUnSeenDiscussion
                              //   .length
                              3
                            }
                          >
                            <Button
                              variant="dark"
                              title="Comments"
                              // onClick={() => {
                              //   handleShow(item);
                              //   getDiscussionCommentList(item);
                              //   setDocPreviewData({
                              //     filePath:
                              //       s3bucketUrl + item.docPath,
                              //     urlType: urlType,
                              //   });
                              // }}
                            >
                              <span className="bx bx-message-rounded-dots"></span>{" "}
                            </Button>
                          </AntdBadge>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between flex-grow-0 flex-shrink-0 flex-width-auto mb-3">
                        <Badge className="bg-secondary">
                          {/* {item &&
                            item.updatedAt &&
                            timeAgo(item.updatedAt)} */}
                          1 day ago
                        </Badge>
                        {/* {documentStatus(item)} */}
                        <Badge
                          variant="success"
                          // variant={
                          //   item?.status === "Accepted"
                          //     ? "success"
                          //     : item?.status === "In-Review"
                          //     ? "warning"
                          //     : item?.status === "Declined" && "danger"
                          // }
                          // bg={success
                          //   item?.status === "Accepted"
                          //     ? "success"
                          //     : item?.status === "In-Review"
                          //     ? "warning"
                          //     : item?.status === "Decline" && "danger"
                          // }
                        >
                          Approved
                        </Badge>
                      </div>
                      <span className="file-details text-truncate">
                        {/* {item.originalPath} */} Rishabh_Joining_Letter.jpg
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
              </div>

              <DataTableComponent
                columns={columns}
                data={signingRequestData.length > 0 && signingRequestData}
                tableError="Document list"
              />
              {/* Comment Bar Starts */}
              {/* {commentBar === true ? (
                  <CommentSideBar
                    closeCommentBar={closeCommentBar}
                    id={selectedDocument}
                  />
                ) : (
                  ""
                )} */}

              <Drawer
                placement="right"
                visible={open}
                // title={commentData?.docName}
                title={"Document Name"}
                onClose={onClose}
              >
                <Container className="p-0">
                  <div className="comment-box">
                    <div className="document-details">
                      <span className="comment-id d-block text-primary font-weight-semibold">
                        #93457
                      </span>
                      <span className="text-muted d-block font-weight-semibold font-14">
                        {/* {commentData?.givenDocName} */}
                        {"Document Name"}
                      </span>
                      <span
                        className="date d-block font-weight-semibold font-14"
                        // key={commentData?.index}
                      >
                        {/* {moment(commentData?.createdAt).format("DD-MMM-YYYY")} */}
                        22-Nov-2022
                      </span>
                      <span className="time d-block">
                        {/* {commentData &&
                            commentData.updatedAt &&
                            moment.utc(commentData.updatedAt).format("HH:mm A")} */}
                        12:11 PM
                      </span>
                    </div>

                    <div className="doc-img">
                      {/* <Image src={editedImage ? editedImage : commentmodel} /> */}
                      {/* {docPreviewData.urlType === "pdf" && (
                          <object
                            data={docPreviewData.filePath}
                            type="application/pdf"
                          />
                        )} */}
                      <Image
                        src={
                          // discussionCommentId?.docPath &&
                          // s3bucketUrl + discussionCommentId?.docPath
                          //   ? s3bucketUrl + discussionCommentId?.docPath
                          //   : commentmodel
                          agreementUpload
                        }
                      />
                      {/* {docPreviewData.urlType === "jpeg" && (
                          <Image
                            src={
                              discussionCommentId?.docPath &&
                              s3bucketUrl + discussionCommentId?.docPath
                                ? s3bucketUrl + discussionCommentId?.docPath
                                : commentmodel
                            }
                          />
                        )}
                        {docPreviewData.urlType === "jpg" && (
                          <Image
                            src={
                              discussionCommentId?.docPath &&
                              s3bucketUrl + discussionCommentId?.docPath
                                ? s3bucketUrl + discussionCommentId?.docPath
                                : commentmodel
                            }
                          />
                        )}
                        {docPreviewData.urlType === "png" && (
                          <Image
                            src={
                              discussionCommentId?.docPath &&
                              s3bucketUrl + discussionCommentId?.docPath
                                ? s3bucketUrl + discussionCommentId?.docPath
                                : commentmodel
                            }
                          />
                        )} */}
                    </div>
                    <div className="d-flex align-items-center">
                      <img
                        src={
                          userImage
                          // commentData &&
                          // commentData.sentBy &&
                          // commentData.sentBy.photo
                        }
                        // onError={addDefaultSrc}
                        className="me-2 rounded-circle shadow"
                        width="40"
                        height="40"
                      />
                      <div>
                        <span className="d-block font-14 font-weight-semibold">
                          {/* {commentData &&
                              commentData.sentBy.firstName +
                                " " +
                                commentData.sentBy.lastName} */}
                          Chintan Rajai
                        </span>{" "}
                        <span className="d-block font-14">
                          {/* {commentData && commentData.sentBy.emailId} */}
                          chintan.rajai@indianic.com
                        </span>
                      </div>
                    </div>
                    <div className="text-sec">
                      <div className="comment-body-scroll">
                        {/* {discussionCommentList &&
                            discussionCommentList
                              .map((item, index) => {
                                return ( */}
                        <div className="comment-box d-flex justify-content-between w-100 mt-3">
                          <div
                            className="comment-content d-flex align-items-center"
                            // key={index}
                          >
                            <img
                              src={profileavtar}
                              className="me-2 rounded-circle align-self-start"
                              width="40"
                              height="40"
                            />
                            <div className="d-block align-self-center">
                              {/* <p>Darlene Robertson</p> */}
                              <span className="d-block font-weight-semibold">
                                {/* {item && item?.msgBy
                                            ? item?.msgBy?.firstName +
                                              " " +
                                              item?.msgBy?.lastName
                                            : offerProfileData.firstName +
                                              " " +
                                              offerProfileData.lastName} */}
                                Chintan Rajai
                                {/* {item && !item.msgBy ? (
                                            <Badge
                                              variant="warning"
                                              className="ms-1"
                                            >
                                              You
                                            </Badge>
                                          ) : JSON.parse(getItem("User"))
                                              ._id === item.msgBy._id ? (
                                            <Badge
                                              variant="success"
                                              className="ms-1"
                                            >
                                              Candidate
                                            </Badge>
                                          ) : (
                                            <Badge
                                              variant="primary"
                                              className="ms-1"
                                            >
                                              IndiaNIC
                                            </Badge>
                                          )} */}
                                <Badge variant="primary" className="ms-1">
                                  IndiaNIC
                                </Badge>
                              </span>
                              <span className="d-block font-12">
                                {/* {item && item?.msg} */} lorem ipsume dolor
                                sit
                              </span>
                            </div>
                          </div>
                          <span className="text-right fw-semibold font-12 flex-shrink-0">
                            {/* {moment
                                        .utc(item.createdAt)
                                        .local()
                                        .startOf("seconds")
                                        .fromNow()} */}
                            05:23 PM
                          </span>
                        </div>
                        {/*   );
                               })
                              .reverse()} */}
                      </div>
                    </div>
                    <Form className="add-comment-textbox">
                      <Form.Group controlId="formBasicComment" className="mb-2">
                        <Form.Label>Add Comment</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          // className={
                          //   errors.comment ? "form-control error-red" : ""
                          // }
                          // value={docummentComment}
                          // onChange={(e) => {
                          //   errors = Object.assign(errors, {
                          //     comment: "",
                          //   });
                          //   setErrors(errors);
                          //   setDocummentComment(e.target.value);
                          // }}
                        />
                        <small className="error-msg" style={{ color: "red" }}>
                          {/* {errors.comment} */} Please add any comment !
                        </small>
                      </Form.Group>
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="primary"
                          className="rounded-pill px-4"
                          type="submit"
                          // onClick={(e) => addComment(e)}
                        >
                          Send
                        </Button>
                      </div>
                    </Form>
                  </div>
                </Container>
              </Drawer>
              {/* Comment Bar Endss */}
            </div>
          </Container>
        </section>
      </MasterLayout>
      <Modal show={show} onHide={closeModalHandler}>
        <Modal.Body>
          <div>Comming Soon...</div>
        </Modal.Body>
        <Button variant="link" onClick={closeModalHandler}>
          Close
        </Button>
      </Modal>
    </>
  );
};

export default Agreements;
